export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const IMAGE_URL = process.env.REACT_APP_BASE_URL?.replace("/api", "/storage/");
export const REACT_APP_PROXY_IMAGE_URL = process.env.REACT_APP_BASE_URL?.replace(
  "/api/",
  "/image-proxy?path=",
);
export const LOGIN = "auth/login";
export const LOGOUT = "auth/logout";
export const REGISTER = "auth/register";
export const FORGOT_PASSWORD = "auth/forgot-password";
export const RESET_PASSWORD = "auth/reset-password";
export const GET_PROFILE = "profile";
export const CHANGE_PASSWORD = "profile/change-password";
export const MASTER_DATA = "master-data";
export const SYSTEM_DATA = "system-data";
export const GET_MEDICINE_LIST = "medicine";
export const GET_MEDICINE_BILL_LIST = "medicine/purchase-bill";
export const GET_MEDICINE_TYPE_LIST = "medicine/type";
export const GET_SERVICE_TYPE_LIST = "service/type";
export const GET_HOSPITAL_LIST = "hospitals";
export const GET_SERVICE_LIST = "services";
export const GET_MEDS_LIST = "medicine";
export const ADD_MEDICINE = "medicine/create";
export const ADD_MEDICINE_TYPE = "medicine/type/create";
export const ADD_SERVICE_TYPE = "service/type/create";
export const ADD_HOSPITAL = "hospitals/upsert";
export const ADD_MEDS = "medicine/type/create";
export const ADD_SERVICE = "services/create";
export const GET_REPORTS = "reports";
export const GET_REPORT_TYPES = "reports/type-list";
export const EDIT_MEDICINE = "medicine/edit/";
export const EDIT_SERVICE = "services/edit/";
export const EDIT_SERVICE_TYPE = "service/type/edit/";
export const EDIT_MEDICINE_TYPE = "medicine/type/edit/";
export const EDIT_HOSPITAL = "hospitals/upsert";
export const CHANGE_HOSPITAL_STATUS = "hospitals/status/";
export const CHANGE_SERVICE_STATUS = "services/status/";
export const CHANGE_SERVICE_TYPE_STATUS = "service/type/status/";
export const CHANGE_MEDICINE_STATUS = "medicine/status/";
export const CHANGE_MEDICINE_TYPE_STATUS = "medicine/type/status/";
export const DELETE_MEDICINE = "medicine/";
export const GET_PURCHASE_MEDICINE_LIST = "medicine/purchase";
export const IMPORT_MASTER = "import/list/";
export const EXPORT_MASTER = "import/";
export const ADD_PURCHASE_MEDICINE = "medicine/purchase/";
export const EDIT_PURCHASE_MEDICINE = "medicine/purchase/update/";
export const MEDICINE_RETURN = "medicine/purchase-return";
export const DELETE_PURCHASE_MEDICINE = "medicine/purchase/delete/";
export const SEARCH_PATIENT = "patient";
export const ADD_PATIENT_VISIT = "patient/create";
export const GET_PATIENTS_LIST = "patient/v2/list";
export const GET_PATIENTS_NEXT_LIST = "patient/next-visit-list";
export const GET_PATIENTS_TRACK_REPORT = "patient/track-report";
export const GET_PATIENT_DETAILS_WITH_VISITS = "patient/";
export const UPDATE_PATIENT_DETAILS = "patient/detail-update/";
export const UPDATE_PATIENT = "patient/update/";
export const ADD_PRESCRIPTION = "patient/prescription/add/";
export const GET_PRESCRIPTION = "patient/prescription/";
export const GET_EXAMINATION = "patient/prescription/examination/";
export const ADD_EXAMINATION = "patient/prescription/add/";

export const GET_MEDICINE_ORDER = "patient/order/";
export const ADD_DAMS = "patient/dams/create";
export const PATIENT_PURCHASE_MEDICINE = "patient/medicine/purchase/";
export const PATIENT_PURCHASE_MEDICINE_CANCEL = "patient/order/cancel/";
export const DELETE_PAYMENT_ENTRY = "patient/order/payment/";
export const SALE_RETURN_LIST = "patient/order/return/list";
export const ADD_SALE_RETURN = "patient/order/return";
export const GET_USERS_LIST = "users";
export const UPSERT_USERS = "users/upsert";
export const CHANGE_USER_STATUS = "users/status/";
export const GET_DASHBOARD_DATA = "dashboard";
export const GET_DASHBOARD_GRAPHS = "dashboard/graph";
export const GET_SUPER_ADMIN_DASHBOARD_DATA = "dashboard/hospital-count";
export const MEDICINE_SALE_HISTORY = "medicine/history/";
export const SERVICE_SALE_HISTORY = "services/sale-history/";
export const GET_SALE_DATA = "dashboard/sale";
export const GET_COLLECTION_DATA = "dashboard/collection";

export const EXPORT_DATA_REQ = "invoice/pdf";
export const DELETE_EXPORT_DATA = "invoice/pdf/delete/";
export const EXPORT_DATA_LIST = "invoice/pdf-list";

export const INVOICE_ORDER_PDF = "invoice/pdf/order/";
export const PRESCRIPTION_PDF = "invoice/pdf/prescription/";

export const PATIENT_INVESTIGATION_DETAILS = "investigation/patient";

export const HOSPITAL_DOCTORS = "hospitals/doctor/";

export const ATTENDANCE = "staff-attendance";
export const GET_EXPENSE_LIST = "expense";
export const ADD_EXPENSE = "expense/create";
export const ADD_BROADCAST = "broadcast/create";
export const EDIT_EXPENSE = "expense/edit/";
export const DELETE_EXPENSE = "expense/delete/";
export const GET_ROOM_LIST = "room";
export const ADD_ROOM = "room/upsert";
export const EDIT_ROOM = "room/upsert";
export const CHANGE_ROOM_STATUS = "room/status/";
export const GET_BED_LIST = "bed";
export const ADD_BED = "bed/upsert";
export const EDIT_BED = "bed/upsert";
export const CHANGE_BED_STATUS = "bed/status/";
export const GET_BED_INFO = "bed/";
export const ADD_IPD = "patient/visit_move_ipd";
export const GET_IPD_LIST = "patient/ipd";
export const SHOW_IPD_STATUS = "patient/ipd/doctor_visit/";
export const GET_IPD_DETAILS_WITH_VISITS = "patient/ipd_details/";
export const DOCTOR_VISIT = "patient/ipd/doctor_visit/";
export const ADD_NOTES = "patient/ipd/note/";
export const PATIENT_DISCHARGE = "patient/discharge/";
export const GET_NOTES = "patient/ipd/note/";
export const ADD_PAYMENT = "patient/ipd/add-payment";
export const GET_ALERT_LIST = "alert";
export const GET_ALERT_MEDICINE_LIST = "alert/detail/medicines";
export const ADD_ALERT = "alert/upsert";
export const DELETE_ALERT = "alert/delete/";

export const CALENDAR_STATS = "calendar/stats";

export const GET_BROADCASE_LIST = "broadcast";
export const EDIT_BROADCAST = "broadcast/update/";
export const DELETE_SCHEDULE = "broadcast/delete/";
export const ADD_TEMPLATE = "template/create";
export const GET_TEMPLATE_LIST = "template";
export const GET_TEMPLATE_DETAIL = "template/";
export const DELETE_TEMPLATE = "template/delete/";
export const GET_DOWNLOAD_EXCEL = "get-whatsapp-excel";
export const GET_PATIENTS = "patient/user-list";
export const AUTO_SUGGESTION = "get-pres-suggestion";

// Notification Partner URLs
export const GET_NOTIFICATION_PARTNERS_LIST = "hospital/notification/channel-partners";
export const UPDATE_NOTIFICATION_PARTNER_CREDENTIALS = "hospital/notification/channel-partners";
export const GET_NOTIFICATIONS_LIST = "hospital/notifications";
export const UPDATE_NOTIFICATIONS = "hospital/notifications/";

export const GET_NOTIFICATION_LOGS_LIST = "hospital/notification/logs";

export const UPDATE_PATIENT_DIAGNOSIS = "diagnosis/visits";
export const UPDATE_PATIENT_TREATMENT = "treatment/add";
export const PATIENT_TREATMENT_DETAILS = "treatment";
export const DELETE_TREATMENT = "treatment/delete/";
export const PATIENT_DIAGNOSIS_DETAILS = "diagnosis/get-visits-diagnosis";
export const GET_PATIENT_DETAILS_WITH_ID = "patient/details/";
export const GET_UPLOADED_FOLDER = "folder";

export const GET_APPLICATION_LIST = "application/type";
export const ADD_APPLICATION = "application/type/create";
export const EDIT_APPLICATION = "application/type/edit/";
export const CHANGE_APPLICATION_STATUS = "application/type/status/";
export const CREDIT_NOTES_LIST = "medicine/purchase-return-list";
export const CREDIT_NOTES_EDIT = "medicine/purchase-return";
export const GET_TREATMENT_LIST = "treatment/type";
export const ADD_TREATMENT = "treatment/type/create";
export const EDIT_TREATMENT = "treatment/type/edit/"; // usage: + id
export const CHANGE_TREATMENT_STATUS = "treatment/type/status/"; // usage: + id + "/status"

export const GET_MEDICINE_CATEGORY_LIST = "medicine_category/type";
export const ADD_MEDICINE_CATEGORY = "medicine_category/type/create";
export const EDIT_MEDICINE_CATEGORY = "medicine_category/type/edit/"; // usage: + id
export const CHANGE_MEDICINE_CATEGORY_STATUS = "medicine_category/type/status/"; // usage: + id + "/status"

export const GET_DEPARTMENT_LIST = "department/type";
export const ADD_DEPARTMENT = "department/type/create";
export const EDIT_DEPARTMENT = "department/type/edit/"; // usage: + id
export const CHANGE_DEPARTMENT_STATUS = "department/type/status/"; // usage: + id + "/status"

export const GET_SUPPLIER_LIST = "supplier/type";
export const ADD_SUPPLIER = "supplier/type/create";
export const EDIT_SUPPLIER = "supplier/type/edit/"; // usage: + id
export const CHANGE_SUPPLIER_STATUS = "supplier/type/status/"; // usage: + id + "/status"

export const GET_DIAGNOSIS = "diagnosis/type";
export const ADD_DIAGNOSIS = "diagnosis/type/create";
export const EDIT_DIAGNOSIS = "diagnosis/type/edit/"; // usage: + id
export const CHANGE_DIAGNOSIS_STATUS = "diagnosis/type/status/"; // usage: + id + "/status"

export const GET_EXPENSE_CATEGORY_LIST = "expense_category/type";
export const ADD_EXPENSE_CATEGORY = "expense_category/type/create";
export const EDIT_EXPENSE_CATEGORY = "expense_category/type/edit/"; // usage: + id
export const CHANGE_EXPENSE_CATEGORY_STATUS = "expense_category/type/status/"; // usage: + id + "/status"

export const UPLOAD_TEMPLATE_MEDIA = "media";
export const ADD_PATIENT = "patient/create/user";

export const GET_INVENTORY_CATEGORY_LIST = "inventory_category/type";
export const ADD_INVENTORY_CATEGORY = "inventory_category/type/create";
export const EDIT_INVENTORY_CATEGORY = "inventory_category/type/edit/"; // usage: + id
export const CHANGE_INVENTORY_CATEGORY_STATUS = "inventory_category/type/status/"; // usage: + id + "/status"

export const GET_INVENTORY_LIST = "inventory";
export const ADD_INVENTORY = "inventory/upsert";
export const ADD_INVENTORY_STOCK = "inventory/stock";
export const ADD_INVENTORY_CONSUME = "inventory/consume";
export const ADD_INVENTORY_COMMENT = "inventory/comment";
export const GET_INVENTORY_HISTORY = "inventory/history";
export const EDIT_INVENTORY = "inventory/upsert";
export const CHANGE_INVENTORY_STATUS = "inventory/status/";
export const GET_CUSTOM_BILLING_ITEM_LIST = "custom_billing_item/type";
export const ADD_CUSTOM_BILLING_ITEM = "custom_billing_item/type/create";
export const EDIT_CUSTOM_BILLING_ITEM = "custom_billing_item/type/edit/";
export const CHANGE_CUSTOM_BILLING_ITEM_STATUS = "custom_billing_item/type/status/";
